import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import validators from '../../utils/validators';
import { Link } from 'react-router-dom';
import CustomDivider from '../../components/CustomDivider';
import { TextFieldComponent } from '../../components/CustomFormElement';

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.text.link,
        textDecoration: 'none',
    },
    button: {
        textTransform: 'capitalize!important',
        marginRight: `${theme.spacing(2)}!important`,
    },
    modalContent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: 24,
        padding: theme.spacing(4),
    },
    otpInput: {
        textAlign: 'center',
        width: '40px',
        height: '40px',
        fontSize: '25px',
    },
}));

export default function RegisterViewV2(props) {
    const { handleRegister, handleOpenModal, handleCloseModal, openModal, obfuscatedValue, handleValidate, onCancel } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [otp, setOtp] = useState(new Array(6).fill('')); 
    const isOtpComplete = otp.every((digit) => digit !== '');
    const handleChangeOtp = (value, index) => {
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1); 
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            const nextInput = document.getElementById(`otp-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleKeyDownOtp = (event, index) => {
        if (event.key === 'Backspace' && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };
    const handleSubmitOtp = () => {
        if (isOtpComplete) {
          const otpString = otp.join('');
          handleValidate(otpString); 
        }
      };
    return (
        <div>
            <Form
                onSubmit={handleRegister}
                render={({ handleSubmit }) => (
                    <Grid xs={12} container item justify="center" alignItems="center">
                        <Grid xs={12} item container justifyContent="center" marginBottom={6}>
                            <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                                <Grid xs={12} item container justifyContent="center">
                                    <Typography variant="h1" color="primary">{t('registration')}</Typography>
                                </Grid>
                                <Grid item xs={12} container justifyContent="center" marginTop={2} className={classes.content_link}>
                                    <Typography variant="body1" color="textSecondary">
                                        {t('Already have an account? ')}
                                        <Link to="/login" className={classes.link}>
                                            {t('Login.')}
                                        </Link>
                                    </Typography>
                                </Grid>
                                <Grid xs={12} item container justifyContent="center" marginTop={2}>
                                    <CustomDivider />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                            <Grid xs={12} item>
                                <Field
                                    fullWidth
                                    name="email"
                                    component={TextFieldComponent}
                                    placeholder={t('email_address')}
                                    validate={validators.composeValidators(validators.validEmail)}
                                />
                            </Grid>
                            <Grid xs={12} item marginTop={3}>
                                <Box style={{ textAlign: 'center' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.button}
                                    >
                                        {t('btn_send')}
                                    </Button>
                                    <Button variant="text" onClick={onCancel} className={classes.button}>
                                        {t('btn_cancel')}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            />
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box className={classes.modalContent}>
                    <Grid xs={12} item container justifyContent="center">
                        <Typography variant="h1" color="primary">{t('Authentication')}</Typography>
                    </Grid>
                    <Grid xs={12} item container justifyContent="center" marginTop={2}>
                        <Typography variant="body1">{t('A one-time password (OTP) has been sent to {{obfuscatedValue}}. Please enter the code below to authenticate.', { obfuscatedValue })}</Typography>
                    </Grid>
                    <Grid container spacing={1.5} justifyContent="center" marginTop={5}>
                        {otp.map((value, index) => (
                            <Grid item key={index}>
                                <TextField
                                    id={`otp-${index}`}
                                    value={value}
                                    onChange={(e) => handleChangeOtp(e.target.value, index)}
                                    onKeyDown={(e) => handleKeyDownOtp(e, index)}
                                    inputProps={{
                                        maxLength: 1,
                                        className: classes.otpInput,
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '18px',
                                        },
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Box marginTop={2} textAlign="center">
                        <Button variant="contained" disabled={!isOtpComplete} color="primary" onClick={handleSubmitOtp}>
                            {t('Authentication & Login')}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
}
